import i18n from '@/plugins/i18n'
/**
 * 设备类型
 */
export const DeviceTypeEnums = {
  DESKTOP: 'desktop',
  MOBILE: 'mobile'
}

/**
 * 权限判断模式
 */
export const PermissionModeEnums = {
  AND: 'and',
  OR: 'or'
}

/**
 * 操作日志 - 业务类型
 */
export const BusinessTypeEnums = {
  OTHER: { label: i18n.t('const.BusinessTypeEnums.OTHER'), value: 0 },
  QUERY: { label: i18n.t('const.BusinessTypeEnums.QUERY'), value: 1 },
  INSERT: { label: i18n.t('const.BusinessTypeEnums.INSERT'), value: 2 },
  UPDATE: { label: i18n.t('const.BusinessTypeEnums.UPDATE'), value: 3 },
  DELETE: { label: i18n.t('const.BusinessTypeEnums.DELETE'), value: 4 },
  EXPORT: { label: i18n.t('const.BusinessTypeEnums.EXPORT'), value: 5 },
  EXPORT_TEMPLATE: { label: i18n.t('const.BusinessTypeEnums.EXPORT_TEMPLATE'), value: 6 },
  IMPORT: { label: i18n.t('const.BusinessTypeEnums.IMPORT'), value: 7 },
  LOGIN: { label: i18n.t('const.BusinessTypeEnums.LOGIN'), value: 8 },
  LOGOUT: { label: i18n.t('const.BusinessTypeEnums.LOGOUT'), value: 9 },
  KICKOUT: { label: i18n.t('const.BusinessTypeEnums.KICKOUT'), value: 10 },
  FORCE_LOGOUT: { label: i18n.t('const.BusinessTypeEnums.FORCE_LOGOUT'), value: 11 },
  PAUSE_RESUME_JOB: { label: i18n.t('const.BusinessTypeEnums.PAUSE_RESUME_JOB'), value: 12 },
  EXEC_JOB: { label: i18n.t('const.BusinessTypeEnums.EXEC_JOB'), value: 13 }
}

/**
 * 菜单类型
 */
export const MenuTypeEnums = {
  DIR: { label: i18n.t('const.MenuTypeEnums.DIR'), value: 1 },
  MENU: { label: i18n.t('const.MenuTypeEnums.MENU'), value: 2 },
  BUTTON: { label: i18n.t('const.MenuTypeEnums.BUTTON'), value: 3 }
}

export const DataScopeEnums = {
  ALL: { label: i18n.t('const.DataScopeEnums.ALL'), value: 1 },
  CUSTOM: { label: i18n.t('const.DataScopeEnums.CUSTOM'), value: 2 },
  DEPT: { label: i18n.t('const.DataScopeEnums.DEPT'), value: 3 },
  DEPT_AND_CHILD: { label: i18n.t('const.DataScopeEnums.DEPT_AND_CHILD'), value: 4 },
  SELF: { label: i18n.t('const.DataScopeEnums.SELF'), value: 5 }
}

export const NoticeTypeEnums = {
  INFO: { label: i18n.t('const.NoticeTypeEnums.INFO'), value: 0 },
  ANNOUNCEMENT: { label: i18n.t('const.NoticeTypeEnums.ANNOUNCEMENT'), value: 1 }
}

export const UserSelectDisableEnums = {
  NORMAL: { label: '可选择', value: 0 },
  DISABLED: { label: '禁止选择', value: 1 }
}

export const PortTypeEnums = {
  NORMAL: { label: '港口', value: 1 },
  SHIPYARD: { label: '船厂', value: 2 }
}

export const PortDistanceTypeEnums = {
  PATH_PLANNING: { label: '路径规划', value: 1 },
  THIRD_PARTY_TRUSTED_DATA: { label: '三方信任数据', value: 2 },
  HISTORICAL_ROUTE_DATA: { label: '历史航线数据', value: 3 },
  ADMIN_FORCE: { label: '管理员强制', value: 4 }
}

export const DestPositionDictTypeEnums = {
  CUSTOM: { label: '自定义', value: 1 },
  PORT_PINYIN_SYNC: { label: '港口拼音同步', value: 2 }
}

export const ShipTypeEnums = {
  SHANHUO: { label: '散货船', value: 20 },
  ZHAHUO: { label: '杂货船', value: 10 },
  JIZHUANGXIANG: { label: '集装箱船', value: 30 },
  GUNZHUANG: { label: '滚装船', value: 40 },
  ZAIBO: { label: '载驳船', value: 50 },
  YOU: { label: '油船', value: 60 },
  YEHUAQI: { label: '液化气船', value: 70 },
  LENGCHANG: { label: '冷藏船', value: 80 },
  JIAYOU: { label: '加油船', value: 90 },
  JIAYOUBO: { label: '加油驳船', value: 100 },
  YINHANG: { label: '引航船', value: 110 },
  SHOUJIU: { label: '搜救船', value: 120 },
  TUOLUN: { label: '拖轮船', value: 130 },
  GANGKOUGONGYING: { label: '港口供应船', value: 140 },
  FANGWENRAN: { label: '载有防污染装置和设备的船舶', value: 150 },
  ZHIFA: { label: '执法艇', value: 160 },
  BEIYONG: { label: '备用-用于当地船舶的任务分配', value: 170 },
  YILIAO: { label: '医疗船', value: 180 },
  JUEYI18: { label: '18号决议船', value: 190 },
  PULAO: { label: '捕捞船', value: 200 },
  TUOYIN: { label: '拖引船', value: 210 },
  DATUOYIN: { label: '大托引船', value: 220 },
  SHUJUN: { label: '疏浚或水下作业船', value: 230 },
  QIANSHUI: { label: '潜水作业船', value: 240 },
  JUNSHI: { label: '军事行动船', value: 250 },
  FANCHUAN: { label: '帆船航行船', value: 260 },
  YULE: { label: '娱乐船', value: 270 },
  DIXIAO: { label: '地效应船', value: 280 },
  GAOSHU: { label: '高速船', value: 290 },
  KECHUAN: { label: '客船', value: 300 },
  OTHER: { label: '其他', value: 999 },
}

export const ShipDeadWeightSourceEnums = {
  USER_CERTIFICATE: { label: '用户证书', value: 10 },
  TRUSTED_THIRD_PARTY: { label: '可信第三方', value: 20 },
  SYSTEM_CALCULATION: { label: '系统计算', value: 30 }
}

export const ShipRunningStatusEnums = {
  BERTHED: { label: '停泊', value: 0 },
  SAILING: { label: '航行中', value: 1 }
}

export const DataExceptionStatusEnums = {
  PENDING: { label: '待处理', value: 0 },
  PROCESSING: { label: '处理中', value: 1 },
  PROCESSED: { label: '已处理', value: 2 },
  IGNORED: { label: '已忽略', value: 3 },
  UNABLE_TO_HANDLE: { label: '无法处理', value: 4 },
  AUTO_PROCESSED: { label: '已自动处理', value: 5 },
  AUTO_IGNORED: { label: '已自动忽略', value: 6 }
}

export const DataExceptionLevelEnums = {
  GENERAL: { label: '一般', value: 1 },
  IMPORTANT: { label: '重要', value: 2 },
  SERIOUS: { label: '严重', value: 3 }
}

export const ShipStatus2Enums = {
  T0_SAILING: { label: '在航', value: 0 },
  T1_ANCHORED: { label: '锚泊', value: 1 },
  T2_UNCONTROLLED: { label: '失控', value: 2 },
  T3_RESTRICTED_OPERATION: { label: '操作受限', value: 3 },
  T4_RESTRICTED_DRAFT: { label: '吃水受限', value: 4 },
  T5_BERTHING: { label: '靠泊', value: 5 },
  T6_AGROUND: { label: '搁浅', value: 6 },
  T7_FISHING: { label: '捕捞作业', value: 7 },
  T8_PADDLE_POWERED: { label: '靠船帆提供动力', value: 8 }
}

export const EmptyOverloadStateEnums = {
  EMPTY: { label: '空载', value: 0 },
  FULL: { label: '重载', value: 5 },
  UNKNOWN: { label: '未知', value: 10 }
}

export const StopProdEnums = {
  NO: { label: '否', value: 0 },
  YES: { label: '是', value: 1 }
}

export const EmptyOverloadPortTypeEnums = {
  ARRIVAL: { label: 'arrival', value: 0 },
  NEARBY: { label: 'nearby', value: 1 }
}

export const ShipAreaEnums = {
  SEA_SHIP: { label: '海船', value: 10 },
  INLAND_DEFAULT: { label: '默认内陆船', value: 20 },
  INLAND_FORCED: { label: '强制内陆船', value: 25 }
}

export const CurrentInChinaEnums = {
  NO: { label: '不在中国', value: 0 },
  YES: { label: '在中国', value: 1 }
}

export const LastBerthPortTypeEnums = {
  ARRIVAL: { label: 'arrival', value: 1 },
  NEARBY: { label: 'nearby', value: 2 }
}

export const VoyageStatusEnums = {
  TO_LOADING_PORT: { label: '前往装载港途中', value: 110 },
  TO_LOADING_PORT_ANCHORAGE_TRANSIT: { label: '前往装港途中锚泊中转江河口', value: 120 },
  ANCHOR_LOADING_PORT: { label: '锚泊装载港', value: 130 },
  BERTH_LOADING_PORT: { label: '靠泊装载港', value: 140 },
  BERTH_LOADING_PORT_PREPARE_DEPARTURE: { label: '靠泊装载港，准备离港', value: 150 },
  TO_DISCHARGE_PORT: { label: '前往卸载港途中', value: 210 },
  TO_DISCHARGE_PORT_ANCHORAGE_TRANSIT: { label: '前往卸港途中锚泊中转江河口', value: 220 },
  ANCHOR_DISCHARGE_PORT: { label: '锚泊卸载港', value: 230 },
  BERTH_DISCHARGE_PORT: { label: '靠泊卸载港', value: 240 },
  BERTH_DISCHARGE_PORT_PREPARE_DEPARTURE: { label: '靠泊卸载港，准备离港', value: 250 }
}

/**
 * 根据 value 或 key 获取字段值
 * @param {Object} enums 枚举对象
 * @param {Number|String} value 要查找的 value 或 key
 * @param {String} field 要返回的字段
 * @param {String} defaultValue 如果没有找到对应的label，返回默认值
 * @returns {String} label
 */
export function enumsParse(enums, value, field = 'label', defaultValue = null) {
  let fieldValue = null
  Object.keys(enums).forEach(key => {
    if (enums[key].value === value || key === value) {
      fieldValue = enums[key][field]
    }
  })
  return fieldValue || defaultValue
}
export function enumsParseLabel(enums, value, defaultValue = null) {
  return enumsParse(enums, value, 'label', defaultValue)
}

/**
 * enums 转换为 list
 * @param {Object} enums 待转换的enums
 * @returns {Array}
 */
export function enumsConvertToList(enums) {
  return Object.keys(enums).map(key => enums[key])
}

/**
 * 页面模式
 */
export const PageMode = {
  Add: {
    label: '新增',
    value: 'add'
  },
  Edit: {
    label: '编辑',
    value: 'edit'
  },
  Detail: {
    label: '详情',
    value: 'detail'
  }
}
